// Univers Code 2 Roues — données structurelles du hub moto
// (contenu éditorial complet porté progressivement depuis code2roues.fr)

export const isMotoHost = () => {
  try { return window.location.hostname.includes('code2roues'); } catch (_) { return false; }
};

export const MOTO_PARCOURS = [
  { id: 'am', code: 'AM · BSR', age: 'Dès 14 ans', desc: 'Cyclomoteur 50 cc ou voiturette. 8 h de formation, ASSR 1 ou 2 requis.', img: 'https://images.unsplash.com/photo-1722217678977-6ab2d1a10b38?w=900&q=75&auto=format&fit=crop' },
  { id: 'a1', code: 'A1', age: 'Dès 16 ans', desc: 'Motocyclette légère 125 cm³ · 11 kW max. Code moto (ETM) + plateau + circulation.', img: 'https://images.unsplash.com/photo-1599360687378-5f8355df9bd5?w=900&q=75&auto=format&fit=crop' },
  { id: 'a2', code: 'A2', age: 'Dès 18 ans', desc: 'Moto jusqu\u2019à 35 kW. Le permis moto de référence : ETM, plateau, circulation.', img: 'https://images.unsplash.com/photo-1608501622839-8a8955239276?w=900&q=75&auto=format&fit=crop' },
  { id: 'passerelle', code: 'A2 → A', age: 'Après 2 ans', desc: 'Formation passerelle de 7 h pour accéder aux motos de toutes puissances.', img: 'https://images.unsplash.com/photo-1544148024-c3759a58ba99?w=900&q=75&auto=format&fit=crop' },
  { id: '125b', code: '125 (B)', age: 'Permis B + 2 ans', desc: 'Formation 7 h — motocyclette légère ou scooter 3 roues avec ton permis voiture.', img: 'https://images.unsplash.com/photo-1582340172451-b4ee5b61e974?w=900&q=75&auto=format&fit=crop' },
  { id: 'l5e', code: 'L5e · 3 roues', age: '3 roues', desc: 'Scooters et trikes 3 roues de plus de 50 cm³ — accessibles avec B + formation.', img: 'https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=900&q=75&auto=format&fit=crop' },
];

export const MOTO_PLATEAU = [
  { n: '01', titre: 'Déplacer la moto', spec: 'Sans le moteur', detail: 'Pousser · reculer · béquiller' },
  { n: '02', titre: 'Allure réduite', spec: 'Sans passager', detail: 'Sans pied au sol · sans arrêt' },
  { n: '03', titre: "Freinage d'urgence", spec: '50 km/h min · radar C6', detail: 'Arrêt avant C5 (sec) ou C4 (mouillé)' },
  { n: '04', titre: 'Avec passager', spec: 'Allure réduite à 2', detail: 'Reprise · parcours · dépose' },
  { n: '05', titre: 'Slalom', spec: '40 km/h min · ligne C7', detail: 'Demi-tour franc en bout de piste' },
  { n: '06', titre: 'Évitement', spec: '50 km/h min · ligne C6', detail: 'Aucun cône touché · arrêt en zone' },
];

export const MOTO_LIVRET = [
  { code: 'C1', verbe: 'Maîtriser', titre: 'Le maniement de la moto', sous: 12 },
  { code: 'C2', verbe: 'Appréhender', titre: 'La route et la circulation', sous: 8 },
  { code: 'C3', verbe: 'Circuler', titre: 'En conditions difficiles', sous: 11 },
  { code: 'C4', verbe: 'Pratiquer', titre: 'Une conduite autonome', sous: 7 },
];

export const MOTO_STATS = [
  { v: '720', l: 'motards tués en 2024 (ONISR)' },
  { v: '22 %', l: 'des tués pour 2 % du trafic' },
  { v: '×25', l: 'surrisque 2RM vs voiture' },
  { v: '90 %', l: 'accidents à facteur comportemental' },
];
